import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../../store';
import {Website} from "../../website";
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {DbServerErrors} from "../../../../shared/interceptors/db-server-errors";
import {SearchByPropertyPipe} from "../../../../shared/pipes/search-by-property.pipe";
import {User} from "../../../../user/user";
import {Observable} from "rxjs";
import {IActivity} from "../../../../activities/activity";
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import {StartAiBuilderDialogComponent} from "../start-ai-builder-dialog/start-ai-builder-dialog.component";
import {AuthService} from "../../../../auth/auth.service";
import {filter} from "rxjs";
import {first, switchMap} from "rxjs/operators";
import {UserSubscription} from "../../../../user/user-subscription";

@Component({
    selector: 'db-recreate-website-steps',
    templateUrl: './recreate-website-steps.component.html',
    styleUrls: ['./recreate-website-steps.component.scss'],
    standalone: false
})
export class RecreateWebsiteStepsComponent implements OnInit, OnDestroy {

  @Input() title: string;
  @Input() description?: string;
  @Input() fromDialog: boolean;
  @Input() websiteId: any;
  public website: Website;
  public subscriptions: Subscription[];
  public loading: boolean;
  public serverErrors: DbServerErrors;
  public isManagable: boolean;
  public ongoingBuilderActivity$: Observable<IActivity>;
  public firstInfoLink: string = "https://help.10web.io/hc/en-us/articles/360030774911-How-do-I-Access-the-PHP-Nginx-Error-Logs-for-My-Website-";
  public user: User;
  public userSubscription: UserSubscription;
  public tabIndex: number = 1;
  public xDown: any = null;
  public yDown: any = null;

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _searchPipe: SearchByPropertyPipe,
    private _route: ActivatedRoute,
    private _dialogService: DialogService,
    private _authService: AuthService,
  ) {
  }

  ngOnInit(): void {
    if (!this.websiteId) {
      this.website = this._route.snapshot.parent.data['websites'];
    }
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUser))
      )
      .subscribe((user: User) => {
        this.user = user;
      });

    this.addEventHandlers();
  }

  private addEventHandlers(): void {
    this.subscriptions = [];
    this.subscriptions.push(this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserSubscription)),
        first()
      )
      .subscribe((userSubscription: UserSubscription) => {
        this.userSubscription = userSubscription;
      }));
  }

  public startAiBuilder(): void {
    this._dialogService
      .addDialog(StartAiBuilderDialogComponent)
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.loading = true;
        }
      });
  }

  ngOnDestroy(): void {
    this.removeEventHandlers();
  }

  private removeEventHandlers(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach((subscription: Subscription): void => {
        subscription.unsubscribe();
      });
    }
    this.subscriptions = null;
  }
  public signOut () {
    if (this._authService.canLogout()) {
      this._authService.logout(null, this.user.id, this.userSubscription);
    }
  }
  public getTouches(evt): void {
    return evt.touches ||             // browser API
      evt.originalEvent.touches; // jQuery
  }

  public handleTouchStart(evt): void {
    const firstTouch = this.getTouches(evt)[0];
    this.xDown = firstTouch.clientX;
    this.yDown = firstTouch.clientY;
  }

  public nextTab(currentTab, left: boolean): void {

    const currentTabIndex = left ? currentTab + 1 : currentTab - 1;
    this.tabIndex = (currentTabIndex === 0 || currentTabIndex === 4) ? this.tabIndex : currentTabIndex;
  }

  public handleTouchMove(evt): void {
    if ( ! this.xDown || ! this.yDown ) {
      return;
    }

    const xUp = evt.touches[0].clientX;
    const yUp = evt.touches[0].clientY;

    const xDiff = this.xDown - xUp;
    const yDiff = this.yDown - yUp;

    if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
      if ( xDiff > 0 ) {
        this.nextTab(this.tabIndex, true);
        /* left swipe */
      } else {
        this.nextTab(this.tabIndex, false);
        /* right swipe */
      }
    }
    /* reset values */
    this.xDown = null;
    this.yDown = null;
  }
}
